/**
 * 系统菜单 充值
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>充值</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.orgName" placeholder="输入客户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" @click="recharge">充值</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" :key="color_index" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="lxkNum" label="练习卡数量"/>
      <el-table-column prop="price" label="价格"/>
      <el-table-column prop="totalPrice" label="总价格"/>
      <el-table-column prop="orgName" label="客户名称"/>
      <el-table-column prop="czqNum" label="充值前数量"/>
      <el-table-column prop="czhNum" label="充值后数量"/>
      <el-table-column prop="bz" label="备注"/>
      <el-table-column prop="createTime" label="创建时间"/>
      <el-table-column prop="ztmc" label="状态"/>

      <el-table-column align="center"  label="操作" width="100">
        <template slot-scope="scope">

          <el-tooltip
            class="item"
            effect="dark"
            content="处理"
            placement="top"
            v-show="scope.row.zt == 1"
          >
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-s-check"
              @click="handleData(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click='closeDialog("edit")'>
      <el-form label-width="100px" ref="form" :model="form" :rules="rules">
        <el-form-item label="客户" prop="orgId">
          <el-select size="small" style="width: 100%" filterable v-model="form.orgId" placeholder="请选择客户">
            <el-option
              v-for="x in orgList"
              :label="x.orgName"
              :value="x.orgId"
              :key="x.orgId"
            @click.native="changeOrg(x)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="练习卡数量" prop="lxkNum">
          <el-input size="small" v-model="form.lxkNum" placeholder="请输入练习卡数量" @input="formatInportData($event,'6','lxkNum',form)"></el-input>
        </el-form-item>

        <el-form-item label="单价" prop="price">
          <el-input size="small" v-model="form.price" placeholder="请输入单价" @input="formatInportData($event,'8,2','price',form)"></el-input>
        </el-form-item>

        <el-form-item label="总价格" prop="totalPrice">
          {{ form.totalPrice = ((form.lxkNum ? Number(form.lxkNum) : 0) * (form.price ? Number(form.price) : 0)) }}
<!--          <el-input size="small" v-model="form.totalPrice" placeholder="自动计算总价格" disabled></el-input>-->
        </el-form-item>

        <el-form-item label="备注" prop="bz">
          <el-input type="textarea" :rows="3" size="small" maxLength="300" v-model="form.bz" placeholder="请输入备注"></el-input>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 处理界面 -->
    <el-dialog title="处理" :visible.sync="handleShow" width="30%" :close-on-click-modal="false" @click="handleShow = false">
      <el-form label-width="100px" ref="form" :model="handleForm">
        <el-form-item label="备注" prop="bz">
          <el-input type="textarea" :rows="3" size="small" maxLength="300" v-model="handleForm.bz" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitHandleForm('form')">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import axios from "axios";
import Template from "../../components/template";
import {
  queryOrgDetail,
  queryOrgList,
  queryOrgListNotPage,
  queryOrgRecharge,
  queryRecharge,
  recharge, updateRecharge
} from "../../api/userMG";
import {formatInportData} from "../../utils/util";
export default {
  data() {
    return {
      color_index: 0,
      loading: false, //是显示加载
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      systemFlag: JSON.parse(localStorage.getItem('userdata')).systemFlag,

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      title: '',
      editFormShow: false,
      orgList: [],
      form: {},
      rules: {
        orgId: [
          { required: true, message: '请选择客户', trigger: 'change' }
        ],
        lxkNum: [
          { required: true, message: '请输入练习卡数量', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入单价', trigger: 'blur' }
        ],
      },

      handleShow: false,
      handleForm: {}

   }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata();
      // 查询客户管理
      this.findOrgList();
    },

    findOrgList() {
      queryOrgListNotPage({lx: this.systemFlag == 1 ? 1:''}).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.orgList = res.data
        }
      })
    },

    changeOrg(item) {
      this.$set(this.form, 'price', item.price);
    },

    // 获取列表
    getdata() {
      // this.identificationRecognize();
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryRecharge(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },

    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },

    // 搜索事件
    search() {
      this.getdata()
    },

    // 充值
    recharge() {
      this.title = '充值'
      this.form = {};
      this.editFormShow = true
    },

    // 添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          // 新增
          recharge(this.form).then(res => {
            this.editFormShow = false
            this.loading = false
            if (res.code == 200) {
              this.getdata()
              this.form = {}
              this.$message({
                type: 'success',
                message: '充值成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('充值失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.form = {};
        this.editFormShow = false
      }
    },

    handleData(index, row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.handleForm = {};
      this.handleShow = true
    },

    submitHandleForm(editData) {
      var params = {
        id: this.form.id,
        bz: this.handleForm.bz
      }
      // 新增
      updateRecharge(params).then(res => {
        this.handleShow = false
        this.loading = false
        if (res.code == 200) {
          this.getdata()
          this.form = {}
          this.$message({
            type: 'success',
            message: '处理成功！'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
        .catch(err => {
          this.editFormShow = false
          this.loading = false
          this.$message.error('处理失败，请稍后再试！')
        })
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.tree-con {
  width: 250px;
  height: 95%;
  vertical-align: text-top;
  margin-top: 20px;
  display: inline-block;
  border: #544E4F 2px solid;
  border-radius: 8px;
}

</style>





// WEBPACK FOOTER //
// src/views/system/topUp.vue